import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import EmpreendimentosMeiliPage from '@/pages/empreendimentos/empreendimentos-meili-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

const empreendimentosSearchSchema = z.object({
  page: z.coerce.number().min(1).optional(),
})

// Rota index para /dashboard/$dashboardId/empreendimentos
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/empreendimentos/',
)({
  validateSearch: empreendimentosSearchSchema,
  component: function EmpreendimentosIndexRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <RequireModule module={MODULES.EMPREENDIMENTOS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.VIEW_IMOB_DATA}>
          <EmpreendimentosMeiliPage dashboardId={dashboardId} />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
